import type { ButtonHTMLAttributes, DetailedHTMLProps, PropsWithChildren } from 'react';

export interface Props extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    isLoading: boolean;
}

export default function SubmitButton({ isLoading, children, className, ...props }: PropsWithChildren<Props>) {
    return (
        <button type="submit" className={className ?? 'btn-primary'} disabled={isLoading} aria-busy={isLoading} {...props}>
            {children}
        </button>
    );
}
